import { Control, Controller, FieldErrors } from 'react-hook-form';
import { WelcomeTemplateFormValues } from '../welcome-templates-form-page';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

interface StepWelcomeTemplateBasicInfoProps {
  control: Control<WelcomeTemplateFormValues>;
  errors: FieldErrors<WelcomeTemplateFormValues>;
  disabled?: boolean;
}

export default function StepWelcomeTemplateBasicInfo({
  control,
  errors,
  disabled,
}: StepWelcomeTemplateBasicInfoProps) {
  return (
    <Stack
      sx={{
        viewTransitionName: 'steps',
      }}
      gap={2}
      width={'100%'}
    >
      <Typography sx={{ mb: 1 }}>
        Please provide a welcome template name and an optional description. You
        also have the option to designate this as the default template.
      </Typography>
      <Stack alignItems="left">
        <Stack flexDirection="column" gap={1}>
          <Controller
            name="templateName"
            control={control}
            render={({ field }) => (
              <TextField
                required
                label="Template Name"
                sx={{ width: 400 }}
                {...field}
                disabled={disabled}
                error={!!errors.templateName}
                helperText={errors?.templateName?.message || ' '}
              />
            )}
          />
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Description"
                sx={{ width: 400 }}
                disabled={disabled}
              />
            )}
          />
          <Controller
            name="default"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => {
                      props.onChange(e.target.checked);
                    }}
                  />
                }
                sx={{
                  marginLeft: 0,
                  width: 'fit-content',
                  '& .MuiFormControlLabel-label': {
                    marginLeft: 1,
                  },
                }}
                label="Default"
              />
            )}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
